/**
 * Cursor pager for the Firm API's lists: Previous and Next over the pages
 * `createCursorPages` remembers.
 */

import type { CursorPages } from "../lib/cursorPages";

export default function CursorPager<C>(props: {
  pages: CursorPages<C>;
  next: C | null | undefined;
}) {
  return (
    <div class="flex items-center justify-between pt-3 text-sm">
      <div class="text-slate-500">Page {props.pages.page()}</div>
      <div class="flex gap-2">
        <button
          class="btn-secondary"
          disabled={props.pages.page() === 1}
          onClick={() => props.pages.previous()}
        >
          Previous
        </button>
        <button
          class="btn-secondary"
          disabled={props.next == null}
          onClick={() => {
            if (props.next != null) props.pages.next(props.next);
          }}
        >
          Next
        </button>
      </div>
    </div>
  );
}
